export const ONBOARDING_WORKFLOW_VIEW_SCOPES = [
  'is-admin',
  'onboarding-workflow:view',
];

export const ONBOARDING_WORKFLOW_CREATE_SCOPES = [
  'is-admin',
  'onboarding-workflow:create',
];

export const ONBOARDING_WORKFLOW_UPDATE_SCOPES = [
  'is-admin',
  'onboarding-workflow:update',
];

export const ONBOARDING_WORKFLOW_CLOSED_WON_SCOPES = Array.from(
  new Set([
    ...ONBOARDING_WORKFLOW_CREATE_SCOPES,
    'onboarding-workflow:closed-won',
  ]),
);

export const ONBOARDING_WORKFLOW_NEW_PARTNER_SCOPES = Array.from(
  new Set([
    ...ONBOARDING_WORKFLOW_CREATE_SCOPES,
    'onboarding-workflow:new-partner',
  ]),
);

export const ONBOARDING_WORKFLOW_ACCOUNT_CHANGE_SCOPES = Array.from(
  new Set([
    ...ONBOARDING_WORKFLOW_UPDATE_SCOPES,
    'onboarding-workflow:account-change',
  ]),
);

export const ONBOARDING_WORKFLOW_DRAFT_SCOPES = Array.from(
  new Set([
    ...ONBOARDING_WORKFLOW_CLOSED_WON_SCOPES,
    ...ONBOARDING_WORKFLOW_NEW_PARTNER_SCOPES,
  ]),
);

export const ONBOARDING_WORKFLOW_REVIEW_SCOPES = Array.from(
  new Set([...ONBOARDING_WORKFLOW_UPDATE_SCOPES]),
);

export const ONBOARDING_WORKFLOW_MENU_SCOPES = Array.from(
  new Set([
    ...ONBOARDING_WORKFLOW_VIEW_SCOPES,
    ...ONBOARDING_WORKFLOW_DRAFT_SCOPES,
    ...ONBOARDING_WORKFLOW_REVIEW_SCOPES,
    ...ONBOARDING_WORKFLOW_ACCOUNT_CHANGE_SCOPES,
  ]),
);

export const ONBOARDING_WORKFLOW_SUCCESS_SCOPES = Array.from(
  new Set([
    ...ONBOARDING_WORKFLOW_DRAFT_SCOPES,
    ...ONBOARDING_WORKFLOW_REVIEW_SCOPES,
  ]),
);

export const onboardingWorkflowViewScope =
  ONBOARDING_WORKFLOW_VIEW_SCOPES.join(',');
export const onboardingWorkflowCreateScope =
  ONBOARDING_WORKFLOW_CREATE_SCOPES.join(',');
export const onboardingWorkflowUpdateScope =
  ONBOARDING_WORKFLOW_UPDATE_SCOPES.join(',');
export const onboardingWorkflowClosedWonScope =
  ONBOARDING_WORKFLOW_CLOSED_WON_SCOPES.join(',');
export const onboardingWorkflowNewPartnerScope =
  ONBOARDING_WORKFLOW_NEW_PARTNER_SCOPES.join(',');
export const onboardingWorkflowAccountChangeScope =
  ONBOARDING_WORKFLOW_ACCOUNT_CHANGE_SCOPES.join(',');
export const onboardingWorkflowDraftScope =
  ONBOARDING_WORKFLOW_DRAFT_SCOPES.join(',');
export const onboardingWorkflowReviewScope =
  ONBOARDING_WORKFLOW_REVIEW_SCOPES.join(',');
export const onboardingWorkflowMenuScope =
  ONBOARDING_WORKFLOW_MENU_SCOPES.join(',');
export const onboardingWorkflowSuccessScope =
  ONBOARDING_WORKFLOW_SUCCESS_SCOPES.join(',');

export const onboardingWorkflowImportClosedWonScope =
  onboardingWorkflowClosedWonScope;
